// extracted by mini-css-extract-plugin
module.exports = {"shareIcon":"styles_shareIcon__87oEx","iconWrapper":"styles_iconWrapper__2Wvbp","shareButton":"styles_shareButton__2PiBh"};